var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3046 6.96783L8.11815 20.9423C7.60477 21.5769 6.8482 21.9339 6.03758 21.9471L1.57922 22C1.33603 22 1.13338 21.8413 1.07934 21.6166L0.0660749 17.3727C-0.109558 16.5926 0.0660749 15.7862 0.579462 15.1648L8.50995 5.24911C8.64505 5.09046 8.88824 5.06534 9.05036 5.183L12.3874 7.74786C12.6035 7.91973 12.9008 8.01228 13.2115 7.97262C13.8735 7.89329 14.3193 7.31157 14.2518 6.69019C14.2113 6.37289 14.0491 6.10847 13.833 5.91015C13.7654 5.85727 10.5905 3.39818 10.5905 3.39818C10.3879 3.23953 10.3473 2.94867 10.5095 2.75168L11.7659 1.17707C12.9278 -0.264011 14.9543 -0.39622 16.589 0.859766L18.467 2.30085C19.237 2.88257 19.7504 3.64938 19.9261 4.45585C20.1287 5.34298 19.9126 6.21423 19.3046 6.96783Z",
    fill: "#C8D4D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIco);
export default __webpack_public_path__ + "static/media/edit-ico.187bf633672a4be9afb19b6565c5c8ab.svg";
export { ForwardRef as ReactComponent };